<template>
	<div class="content">
		<div class="header flex-row">
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-categoryed.svg">
				选择预约类型
			</div>
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-infoed.svg">
				填写预约信息
			</div>
			<div class="step-item flex-column" style="color: #ffffff;">
				<img src="../../assets/img/icon-order.svg">
				确认订单结算
			</div>
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-settlemented.svg">
				订单预约成功
			</div>
		</div>
		<div class="section">
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>确认参观人信息</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="table">
				<div class="tableHeader flex-row">
					<div class="item">
						序号
					</div>
					<div class="item">
						姓名
					</div>
					<div class="item">
						证件类型
					</div>
					<div class="item">
						证件号码
					</div>
					<div class="item">
						门票名称
					</div>
					<div class="item">
						票价
					</div>
				</div>
				<div class="tBody">
					<div class="th flex-row" v-for="(item,index) in list" :key="index">
						<div class="data">
							{{index}}
						</div>
						<div class="data">
							虹猫
						</div>
						<div class="data">
							身份证
						</div>
						<div class="data">
							244************488
						</div>
						<div class="data">
							普通票
						</div>
						<div class="data">
							￥72
						</div>
					</div>
				</div>
			</div>
			<div class="date">
				参观日期：2023-03-21 星期二(Tue)09:00-10:00
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>支付方式</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="paymode flex-row">
				<div class="item">
					<el-radio v-model="radio" label="1"> <img src='../../assets/img/icon-juhe.png'> 聚合支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="2"> <img src='../../assets/img/icon-wechat.png'> 微信支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="3"> <img src='../../assets/img/icon-Alipay.png'> 支付宝支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="4"> <img src='../../assets/img/icon-rmb.png'> 数字人民币</el-radio>
				</div>
			</div>
			<img class="line" src='../../assets/img/icon-line.svg'>
			<div class="btnbox flex-row">
				<div class="backbtn cursorp">
					返回上一步
				</div>
				<router-link to="ReservationSuccess">
					<div class="prevbtn cursorp">
						确认订单并结算
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'ConfirmOrder',
		data() {
			return {
				list: [1, 2, 3, 4],
				radio: ''
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		margin: auto;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
	}

	.header {
		width: 100%;
		height: 70px;
		background-image: url(../../assets/img/step3.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding: 0 83px;
		box-sizing: border-box;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.header .step-item {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BB2916;
	}

	.header .step-item img {
		width: 26px;
		height: 26px;
		margin-bottom: 6px;
	}

	.header .step-item img:first-child {
		width: 30px;
		height: 24px;
	}

	.header .step-item img:last-child {
		width: 26px;
		height: 24px;
	}

	.section {
		width: 100%;
	}

	.section .table {
		width: 1007px;
		padding: 0 60px;
		box-sizing: border-box;
	}

	.table .tableHeader {
		width: 1007px;
		height: 64px;
		border-radius: 6px 6px 0px 0px;
		background-image: url('../../assets/img/tableBG.svg');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		justify-content: space-between;
	}

	.table .tableHeader .item {
		font-size: 16px;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		width: 167px;
		text-align: center;
	}

	.table .tBody {
		width: 1007px;
		border: 1px solid #F1F1F1;
	}

	.table .tBody .th {
		width: 100%;
		height: 63px;
		justify-content: space-between;
		border-bottom: 1px solid #F1F1F1;
	}

	.table .tBody .th:last-child {
		border: none !important;
	}

	.tBody .th .data {
		font-size: 16px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		width: 167px;
		text-align: center;
	}

	.section .date {
		margin-top: 16px;
		margin-bottom: 24px;
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #B57C0B;
		margin-left: 60px;
	}

	.section .paymode {
		padding: 0 60px;
		box-sizing: border-box;
		width: 100%;
	}

	.section .paymode .item {
		margin-right: 16px;
	}

	.section .paymode .item img {
		width: 48px;
		height: 48px;
		margin-right: 14px;
	}

	.line {
		width: 1038px;
		height: 6px;
		margin: 24px 0;
		margin-left: 60px;
	}

	.btnbox {
		justify-content: center;
	}

	.btnbox div {
		width: 324px;
		height: 60px;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		text-align: center;
		line-height: 60px;
		border-radius: 30px;
	}

	.btnbox .backbtn {
		color: #3A6E61;
		background: #FFFFFF;
		border: 1px solid #3A6E61;
		margin-right: 32px;
	}

	.btnbox .prevbtn {
		color: #FFFFFF;
		background: #BB2916;
	}

	/deep/ .el-radio {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	/deep/.el-radio .el-radio__label {
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #000000;
	}

	/deep/ .el-radio__inner {
		width: 20px;
		height: 20px;
		background: #F3F3F3;
		border: 2px solid #BB2916
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #BB2916;
		background: #BB2916;

	}

	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #000000;
	}
</style>